import { create } from "zustand";
import { persist } from "zustand/middleware";

interface GuidesState {
  dismissedGuideIds: string[];
  isDismissed: (id: string) => boolean;
  dismissGuide: (id: string) => void;
}

export const useGuidesStore = create<GuidesState>()(
  persist(
    (set, get) => ({
      dismissedGuideIds: [],

      isDismissed: (id: string) => get().dismissedGuideIds.includes(id),

      dismissGuide: (id: string) => {
        if (get().dismissedGuideIds.includes(id)) return;
        set({ dismissedGuideIds: [...get().dismissedGuideIds, id] });
      },
    }),
    {
      name: "guides-storage",
      partialize: (state) => ({ dismissedGuideIds: state.dismissedGuideIds }),
    }
  )
);
